import { render, staticRenderFns } from "./WagonAggreementGrid.vue?vue&type=template&id=537686d6&scoped=true"
import script from "./WagonAggreementGrid.vue?vue&type=script&lang=js"
export * from "./WagonAggreementGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537686d6",
  null
  
)

export default component.exports